import axios from "axios"

const local = false
const url = local ? "http://localhost:5761/api" : "https://textarea.benjamin-widawski.com/api"

const api = {
    check: (callback) => {
        axios.get(url)
            .then(callback)
    },
    getTexts: async () => {
        return await axios.get(url + "/texts")
    },
    getText: async (name) => {
        return await axios.get(url + "/text/" + name)
    },
    updateText: (name, newText) => {
        return new Promise((resolve, _) => {
            axios.post(url + "/text/" + name, {
                value: newText
            })
                .then(result => resolve(result.data))
        })
    },
    deleteTab: (name) => {
        return new Promise((resolve, _) => {
            axios.post(url + "/delete?name=" + name, {})
                .then(result => resolve(result.data))
        })
    },
}

export default api